module.exports = __webpack_public_path__ + "static/media/code-content.206e924a.svg";